export default __webpack_public_path__ + "static/forge-fd83d58e957dec06b7a10ba13b151a971716e9bbd6af18d75e512e7aa3898a0d.png";